import marked from 'marked';
export const mark = (markdown, inline = true) => {
    const stripP = (html) => html.replace(/^<p>/i, '').replace(/<\/p>[\n\r\s]*$/i, '');
    const m = marked(markdown);
    return inline ? stripP(m) : m;
};
